import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContext';

const Logout = () => {
  const { setToken } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    setToken(null);

    // Remove the token from local storage
    localStorage.removeItem('token');

    navigate('/login');
  }, [navigate, setToken]);

  return <div>Logging out...</div>;
};

export default Logout;
